import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityPro2doc } from "../../entity/EntityPro2doc";

export class DtoPro2docsGetRes extends EntityPro2doc {
  public items: EntityPro2doc[]  = [];
}
